import styled from"@emotion/styled";import{Table}from"../../../../common";import{InfoTooltip}from"@wp/src/components/common/tooltip";import{FlexLayout}from"@wp/src/components/common/grid";export const PortfolioInvestmentsTable=Table;export const StyledPriceTooltip=styled(InfoTooltip)`
  min-height: 12px;
  min-width: 12px;
  position: relative;
  top: 4px;
`;export const SharesAmountTableColumnContainer=styled(FlexLayout)`
  flex-direction: column;
  min-width: 120px;
  align-items: flex-start;
  align-content: flex-start;
  row-gap: 2px;
  justify-content: space-between;
`;